import * as Constant from "@/constant";
export default {
  data() {
    if (this.$options === undefined || this.$options.enums === undefined) {
      return {};
    }
    const data = {};
    this.$options.enums.forEach((key) => {
      data[key] = Constant[key];
    });
    return data;
  },
};
